import React, { useCallback, useEffect, useState } from 'react';
import { clusterView, CLUSTER_VIEW_KEY } from '../api';
import Workers from './Workers';

/**
 * /cluster для тих, хто не адмін кабінету: форма пароля → сторінка в режимі
 * перегляду. Пароль задає адмін у блоці «Зробити сторінку видимою іншим».
 */
function readTok() {
  try { return localStorage.getItem(CLUSTER_VIEW_KEY); } catch (e) { return null; }
}
function writeTok(v) {
  try {
    if (v) localStorage.setItem(CLUSTER_VIEW_KEY, v);
    else localStorage.removeItem(CLUSTER_VIEW_KEY);
  } catch (e) { /* приватне вікно — сесія житиме до перезавантаження */ }
}

export default function ClusterViewer() {
  const [tok, setTok] = useState(readTok());
  const [open, setOpen] = useState(null);        // null = ще не знаємо
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (tok) return;
    clusterView.status().then(r => setOpen(!!r.data?.open))
      .catch(() => setOpen(true));               // сервер недоступний — форма все одно
  }, [tok]);

  const onUnauthorized = useCallback(() => {
    writeTok(null);
    setTok(null);
    setErr('Доступ змінено адміністратором — введіть пароль ще раз.');
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await clusterView.login(password);
      writeTok(r.data.token);
      setPassword('');
      setTok(r.data.token);
    } catch (e2) {
      setErr(e2?.response?.data?.detail || e2.message);
      if (e2?.response?.status === 403) setOpen(false);
    } finally {
      setBusy(false);
    }
  };

  // Той самий фон і поля, що й у кабінеті адміна (AppShell): без обгортки
  // сторінка лягала на темний фон body бектестингу.
  if (tok) return (
    <div style={S.shell}>
      <Workers viewer onUnauthorized={onUnauthorized} />
    </div>
  );

  return (
    <div style={S.page}>
      <form onSubmit={submit} style={S.card}>
        <h2 style={S.h2}>Кластер</h2>
        {open === false ? (
          <p style={S.text}>Сторінка закрита для перегляду. Зверніться до адміністратора.</p>
        ) : (
          <>
            <p style={S.text}>Введіть пароль перегляду, який дав адміністратор.</p>
            <input
              type="password" value={password} autoFocus
              onChange={ev => setPassword(ev.target.value)}
              placeholder="Пароль" autoComplete="current-password" style={S.input}
            />
            <button type="submit" disabled={busy || !password} style={S.btn}>
              {busy ? 'Перевіряю…' : 'Відкрити'}
            </button>
          </>
        )}
        {err && <div style={S.err}>{err}</div>}
        <a href="/login" style={S.link}>Вхід для адміністратора</a>
      </form>
    </div>
  );
}

const S = {
  shell: { minHeight: '100vh', background: '#F4F6FB', color: '#101828',
           padding: window.innerWidth < 768 ? '10px 12px 16px' : '24px 28px',
           boxSizing: 'border-box', overflowX: 'hidden',
           fontFamily: "'Inter','Segoe UI',system-ui,sans-serif" },
  page:  { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
           background: '#F4F6FB', padding: 16, boxSizing: 'border-box' },
  card:  { background: '#FFFFFF', borderRadius: 12, padding: 24, width: '100%', maxWidth: 360,
           boxShadow: '0 4px 20px rgba(0,0,0,0.06)', display: 'flex', flexDirection: 'column', gap: 12 },
  h2:    { margin: 0, fontSize: 22, color: '#1A1A1A' },
  text:  { margin: 0, color: '#5B646F', lineHeight: 1.5 },
  input: { padding: '10px 12px', border: '1px solid #E5E7EB', borderRadius: 8, fontSize: 15 },
  btn:   { padding: '10px 12px', border: 'none', borderRadius: 8, background: '#2563EB',
           color: '#FFFFFF', fontSize: 15, cursor: 'pointer' },
  err:   { color: '#B91C1C', fontSize: 14 },
  link:  { color: '#5B646F', fontSize: 13, textAlign: 'center' },
};
